import styled from "styled-components";

export const MedicationRange = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
  .title {
    color: #3E3DA3;
    font-family: Nunito Sans;
    font-size: 16px;
    margin-top: 10px;
  }
  .calendar-inputs {
    margin: 20px 15px 28px;
    display: flex;
    justify-content: space-between;
    .input-container {
      display: flex;
      align-items: center;
      .input-label {
        margin-right: 10px;
        color: #3E3E5B;
        font-family: "Nunito Sans";
        font-size: 14px;
      }
      &--unfocus {
        opacity: 0.3;
      }
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
  .calendar-range-container {
    display: flex;
    .calendar-range {
      margin: auto;
      width: 300px;
    }
  }
  .toogle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-family: "Nunito Sans Light";
      font-size: 15px;
      color: #526479;
      margin-right: 10px;
    }
  }
`